<template>
	<div class="container-fluid">
		<div class="col-12 font-size-10 p-0 font-size-sm-9">
			<div class="collapse show" id="detailTransaksi" v-show="Object.values(transactionOne).length == 0">
				<div class="row">
					<div class="col-12 pl-0 pl-md-3 pr-2 pr-md-3">
						<vcl :width='400' :height='300'>
							<rect x="0" y="0" rx="2" ry="2" width="430" height="15" />
							<rect x="0" y="25" rx="2" ry="2" width="170" height="45" />
							<rect x="180" y="25" rx="2" ry="2" width="220" height="45" />
							<rect x="0" y="80" rx="2" ry="2" width="130" height="32" />
							<rect x="135" y="80" rx="2" ry="2" width="130" height="32" />
							<rect x="270" y="80" rx="2" ry="2" width="130" height="32" />
							<rect x="0" y="120" rx="2" ry="2" width="130" height="73" />
							<rect x="135" y="120" rx="2" ry="2" width="130" height="73" />
							<rect x="270" y="120" rx="2" ry="2" width="130" height="73" />
							<rect x="0" y="200" rx="2" ry="2" width="430" height="60" />
						</vcl>
					</div>
				</div>
			</div>
			<div class="collapse show" id="detailTransaksi" v-if="Object.values(transactionOne).length > 0">
				<div class="row">
					<div class="col-12 pl-0 pl-md-3 pr-2 pr-md-3">
						<div class="col-12 background-gray-light rounded pt-2 pb-2">
							<div class="row">
								<div class="col-12 font-size-12 text-purple d-flex">
									<div class="mt-auto mb-auto pr-2"><i class="fas fa-history "></i></div>
									<div class="font-size-11 font-size-sm-10" v-if="transactionOne.trx_status == 5">Pembatalan pemesanan Produk dengan kode transaksi {{transactionOne.trx_code}} telah berhasil dibatalkan</div>
									<div class="font-size-11 font-size-sm-10" v-else>{{transactionOne.trx_status | toStatus}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-12 pl-0 pl-md-3 pr-3 pr-md-3 mt-3 mt-md-4">
						<div class="row">
							<div class="col-12 col-lg-5 pl-4">
								<div class="row pl-2 pr-2 pr-md-3 pr-lg-2">
									<div class="col-12 d-flex background-gray-light rounded pt-3 pb-3 ship-type">
										<div class="col-2 col-md-1 font-size-12 text-purple">
											<i class="fas fa-user"></i>
										</div>
										<div class="col-10 col-lg-10">
											<div class="font-size-12 font-size-sm-10">{{transactionOne.trx_buyer_name}} <span class="font-size-10 font-size-sm-9">({{transactionOne.trx_buyer_mobilephone}})</span></div>
											<div>{{transactionOne.trx_buyer_email}}</div>
											<div>{{transactionOne.trx_buyer_network_id > 0 ? 'Mitra' : 'Non Mitra' }}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-lg-7 mt-3 mt-lg-0 ml-2 ml-lg-0">
								<div class="row pl-2 pr-3 pr-md-4 pr-lg-3">
									<div class="col-12 d-flex background-gray-light rounded pt-3 pb-3 ship-type">
										<div class="col-2 col-md-1 font-size-12 text-purple">
											<i class="fas fa-truck"></i>
										</div>
										<div class="col-10 col-lg-10 pl-lg-0">
											<div>Jenis Pengambilan</div>
											<div class="text-purple">{{transactionOne.trx_shipping_method | shipping}}
												<span v-if="transactionOne.trx_shipping_method == '1'">, {{transactionOne.shipping_courier.trx_shipping_courier_name}} - {{transactionOne.shipping_courier.trx_shipping_courier_service}}<span v-if="transactionOne.shipping_courier.trx_shipping_courier_number != '0'">, {{transactionOne.shipping_courier.trx_shipping_courier_number}}</span></span>
												<span v-if="transactionOne.trx_shipping_method == '0'">, Tanggal Pengambilan : {{transactionOne.shipping_pickup.trx_shipping_pickup_plan_date | tanggal }}<span v-if="transactionOne.shipping_pickup.trx_shipping_pickup_taken_by">, Diambil Oleh : {{transactionOne.shipping_pickup.trx_shipping_pickup_taken_by}}</span></span>
											</div>
											<div v-if="transactionOne.trx_shipping_method == '1'">{{transactionOne.shipping_courier.trx_shipping_courier_address}}, {{transactionOne.shipping_courier.trx_shipping_courier_subdistrict_name}}, {{transactionOne.shipping_courier.trx_shipping_courier_city_type}} {{transactionOne.shipping_courier.trx_shipping_courier_city_name}}, {{transactionOne.shipping_courier.trx_shipping_courier_province_name}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-12 pb-3 pl-0 pl-md-3 pr-1 pr-md-3 mt-4">
						<div class="row pl-3 pr-3">
							<div class="col-lg-12">
								<div class="row">
									<div class="col-lg-4 pl-0 pr-0 pr-lg-3 text-white text-center">
										<div class="col-12 bg-purple-dark rounded pt-3 pb-3">
											<div class="font-size-12 font-size-sm-10">Kode Transaksi</div>
											<div class="font-size-11 font-size-sm-9">{{transactionOne.trx_code}}</div>
										</div>
									</div>
									<div class="col-lg-4 pl-0 pr-0 pr-lg-3 text-white text-center mt-2 mt-lg-0">
										<div class="col-12 bg-purple-dark rounded pt-3 pb-3">
											<div class="font-size-12 font-size-sm-10">Tanggal Transaksi</div>
											<div class="font-size-11 font-size-sm-9">{{transactionOne.trx_datetime | tanggal}}</div>
										</div>
									</div>
									<div v-if="transactionOne.trx_shipping_method == '1'" class="col-lg-4 pl-0 pr-0 text-white text-center mt-2 mt-lg-0">
										<div class="col-12 bg-purple-dark rounded pt-3 pb-3">
											<div class="font-size-12 font-size-sm-10">Tanggal Pengiriman</div>
											<div class="font-size-11 font-size-sm-9">{{ shippingDate.trx_status_datetime | tanggal }}</div>
										</div>
									</div>
									<div v-if="transactionOne.trx_shipping_method == '0'" class="col-lg-4 pl-0 pr-0 text-white text-center mt-2 mt-lg-0">
										<div class="col-12 bg-purple-dark rounded pt-3 pb-3">
											<div class="font-size-12 font-size-sm-10">Tanggal Pengambilan</div>
											<div class="font-size-11 font-size-sm-9">{{transactionOne.shipping_pickup.trx_shipping_pickup_plan_date | tanggal}}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-lg-4 mt-4" v-for="(value, index) in transactionOne.products.filter(el => el.serial > 0)" v-bind:key="index">
								<div class="row pr-lg-3">
									<div class="col-lg-12 pt-2 pb-2 cus-box-shadow rounded serial-value-box">
										<div class="mb-lg-2 pt-1 pb-2 pl-2 font-size-9 text-center serial-badge serial-ka"><span class="serial-badge-text font-size-11 font-size-sm-10">{{value.code}}</span></div>
										<div class="row">
											<div class="col-11 body-serial-dt" v-if="value.serial_data.length == 0">
												<div class="pl-2 pb-2 text-center">
													<img src="assets/icon/stock_empty.svg" width="100px;" class="mt-n3">
													<p class="mb-n1 font-size-sm-9 font-size-9">Belum Ada Serial Dijual</p>
												</div>
											</div>
											<div class="col-11 body-serial-dt" v-else>
												<div class="pl-2 pb-2" v-for="(val, idx) in value.serial_data" v-bind:key="idx"><img src="assets/icon/serial_card.svg" class="w-2 pr-2">{{val.serial_value}}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-12 mt-2 mt-lg-3 pb-3 pl-0 pl-md-3 pr-1 pr-md-3">
						<div class="row pl-3 pr-3">
							<div class="col-12 pl-0 pr-0 rounded cus-box-shadow font-size-11 font-size-sm-9 detail-buy">
								<div><img class="beg-1" src="/assets/icon/beg_1.svg"></div>
								<div class="d-none d-lg-block"><img class="bag" src="/assets/icon/bag.svg"></div>
								<div><img class="beg-2" src="/assets/icon/beg_2.svg"></div>
								<div class="col-12 col-lg-10 offset-lg-2 pt-3 pb-3 pl-0 pr-0 pl-md-3 pr-md-3">
									<div class="col-12 pt-2 pl-0 pr-0 pl-md-3 pr-md-3" v-for="(value, index) in transactionOne.products" v-bind:key="index">
										<div class="col-12 p-0 d-flex flex-wrap">
											<div class="col-12 col-lg-4">
												<div>{{ value.name }}</div>
											</div>
											<div class="col-5 col-lg-3 pl-4 pr-0 pl-lg-3 pr-lg-3">
												<div>@ {{ value.price_base | toRupiah }}</div>
											</div>
											<div class="col-2 col-lg-1 pr-0 pr-lg-3">
												<div>{{ value.quantity }}</div>
											</div>
											<div class="col-5 col-lg-3 text-right text-purple-dark">
												<div>{{ value.price_total | toRupiah }}</div>
											</div>
										</div>
									</div>
									<div class="col-12 pt-2 pl-0 pr-0 pl-md-3 pr-md-3 d-flex" v-if="transactionOne.trx_shipping_method==1">
										<div class="col-6">
											<div>Ongkos Kirim</div>
										</div>
										<div class="col-6 col-lg-5 text-right text-purple-dark">
											<div>{{ transactionOne.trx_price_shipping | toRupiah }}</div>
										</div>
									</div>
									<div class="col-12 pt-2 pl-0 pr-0 pl-md-3 pr-md-3 d-flex font-weight-bold">
										<div class="col-6">
											<div>Total Transaksi</div>
										</div>
										<div class="col-6 col-lg-5 text-right text-purple-dark">
											<div>{{ transactionOne.trx_price_grand_total | toRupiah }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	computed:{
		...mapState('transactionList', ['transactionOne']),

		shippingDate() {
			if (this.transactionOne.trx_shipping_method == 1 && this.transactionOne.trx_status > 5 ) {
				let date_shipping = this.transactionOne.trx_status_log.find(element => element.trx_status_code == 6);
				return date_shipping;
			} else {
				return '-';
			}
		}
	}
}
</script>

<style>
.detail-buy {
	min-height: 146px;
}
.serial-value-box{
	min-height: 200px
}
.bg-purple-dark {
	background-color: #7C1CC6;
}
.w-2 {
	width: 2em;
}
.body-serial-dt {
	max-height: 136px;
	overflow-y: auto;
}
.text-purple-dark {
	color: #6111CD;
}
.list-serial {
	position: absolute;
	left: 16em;
}
.pt-11 {
	padding-top: 11em;
}
.bag {
	position: absolute;
	bottom: 1rem;
	left: 1rem;
}
.beg-1 {
	position: absolute;
	left: 0;
	bottom: 0;
}
.beg-2 {
	position: absolute;
	right: 0;
	top: 0;
}
@media (min-width: 768px) and (max-width: 800px) {
	.list-serial {
		left: 0em;
	}
}
@media (min-width: 425px) and (max-width: 768px) {
	.list-serial {
		left: 0em;
	}
}
@media (min-width: 375px) and (max-width: 425px) {
	.list-serial {
		left: 0em;
	}
}
@media (min-width: 335px) and (max-width: 374px) {
	.list-serial {
		left: 0em;
	}
}
@media (min-width: 320px) and (max-width: 334px) {
	.list-serial {
		left: 0em;
	}
}
</style>